import ShareButton from "../ShareButton/ShareButton";
import { useFindInPage } from "../../hooks/FindInPageHooks/useFindInPage";
import classNames from "classnames";
import styles from "./TopicActionBar.module.scss";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";
import { useOpenInModal } from "../../hooks/OpenInModalHooks/useOpenInModal";
import useShareTopic from "../../hooks/shareTopicHooks/useShareTopic";
import FontSizeAdjustorButton from "../FontSizeAdjustor/FontSizeAdjustorButton";
import { useFontSizeAdjustor } from "../../hooks/fontSizeAdjustorHooks/useFontSizeAdjustor";

const TopicActionBar = () => {
  const { isMobileView, isAppMode } = useAppModernisation();
  const findInPage = useFindInPage();
  const tableOfContents = useTableOfContents();
  const openInModal = useOpenInModal();
  const shareModal = useShareTopic();
  const fontSizeAdjustor = useFontSizeAdjustor();

  const iconToc = classNames("tg-icons-FormattedListBullet", "iconSize");
  const iconFindInPage = classNames("tg-icons-FindInPage", "iconSize");
  const standardButtonStyle = classNames("size-14", styles.button);

  const isModalOpened = () => {
    return (
      tableOfContents.isOpen ||
      findInPage.isOpen ||
      openInModal.isOpen ||
      shareModal.isOpen ||
      fontSizeAdjustor.isOpen
    );
  };

  return (
    !isModalOpened() && (
      <div
        className={classNames(styles.wrapper, { [styles.appMode]: isAppMode })}
      >
        <div className={styles.iconGroup}>
          {isMobileView && (
            <button
              type="button"
              className={standardButtonStyle}
              aria-label="Page Table of Contents Panel"
              onClick={tableOfContents.openModal}
            >
              <i className={iconToc}></i>
            </button>
          )}
          <button
            type="button"
            className={standardButtonStyle}
            aria-label="Find in page"
            onClick={findInPage.openModal}
          >
            <i className={iconFindInPage}></i>
          </button>
          <FontSizeAdjustorButton
            onClick={fontSizeAdjustor.openModal}
            styling={standardButtonStyle}
          />
          <ShareButton
            open={shareModal.isOpen}
            onClick={shareModal.openModal}
            styling={standardButtonStyle}
          />
        </div>
      </div>
    )
  );
};

export default TopicActionBar;
